const RateLimit = require("async-sema").RateLimit;

let rps = 0.5;

try {
    rps = parseFloat(process.env.REQUESTS_PER_SECOND || 0.5);
} catch (e) {
    console.log(
        "COULD NOT PARSE REQUESTS_PER_SECOND value. Using default of 0.5"
    );
}

// console.log(`===SETTING UP LIMITER WITH A RATE OF ${rps} REQUESTS PER SECOND`);

const limiter =
    process.env.npm_lifecycle_event === "build"
        ? // Rate limit to X requests per second, per thread
          // To avoid maxing out the WP Engine server
          RateLimit(rps)
        : // If not in the build phase, return an immediate Promise resolution
          () => {
              return Promise.resolve(true);
          };

module.exports = limiter;
